export const NO_PAGE_CACHE = 'no-page-cache';
export const NO_COMPONENT_CACHE = 'no-component-cache';
export const NO_CACHE = 'no-cache';
export const DISABLE_STOCK_FILTER = 'disableStockFilter';
export const SHOW_WEBFORM = 'show-webform';
export const SHOW_CONFIRMATION = 'show-confirmation';
export const OPEN_HELP_CENTRE_WEBFORM = 'help-centre';
export const ORDER_NUMBER = 'order';
